import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@/shared/components/atoms';

import Question from '~/images/shared/Question.svg';

const Contact = () => {
  const { t } = useTranslation('payment');
  return (
    <div className='my-32 flex w-full flex-col items-center gap-24 rounded-2xl bg-white p-32'>
      <span className='text-60'>
        <Question />
      </span>
      <div className='flex flex-col justify-center gap-8 text-center'>
        <Typography
          className='text-text-default'
          variant='h3'
          weight='semiBold'
        >
          {t('have-questions')}
        </Typography>
        <Typography className='text-surface-10' variant='body1'>
          {t('have-questions-description')}
        </Typography>
      </div>
      {/* <Button>{t('chat-us')}</Button> */}
    </div>
  );
};

export { Contact };
